export default __webpack_public_path__ + "static/media/ktp700.076ca1eb.png";